import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { ProfileTab } from "features/user/constants";

type ProfileSegmentControlProps = {
  value: ProfileTab;
  onChange: (tab: ProfileTab) => void;
};

const SegmentButton = ({
  active,
  labelKey,
  iconName,
  onClick,
}: {
  active: boolean;
  labelKey: string;
  iconName: string;
  onClick: () => void;
}) => (
  <button
    className={`type-inherit-font flex-col-el flex-center gap-1 w-full h-[130px] px-2 py-2 rounded-2xl border-2 border-solid cursor-pointer transition-colors shadow-[0_3px_0_rgba(63,74,97,0.14),0_4px_10px_rgba(63,74,97,0.08)] active:translate-y-[2px] ${
      active
        ? "border-green-80 bg-green-60 text-textcolor-black"
        : "border-outline bg-white text-textcolor-black/60 hover:bg-green-40/20"
    }`}
    onClick={onClick}
  >
    <div className="flex-col-el flex-center w-[48px] h-[48px] shrink-0">
      <span className="material-symbols-outlined type-hero !leading-none">{iconName}</span>
    </div>
    <p className="type-text type-sm leading-tight whitespace-pre text-center">{I18n.t(labelKey)}</p>
  </button>
);

export const ProfileSegmentControl = ({ value, onChange }: ProfileSegmentControlProps) => {
  const play = usePlaySound();

  const handleClick = (tab: ProfileTab) => () => {
    play();
    onChange(tab);
  };

  return (
    <div className="flex-col-el gap-3 w-full">
      <SegmentButton
        active={value === ProfileTab.BASIC}
        labelKey="MSG_PROFILE_TAB_BASIC"
        iconName="person"
        onClick={handleClick(ProfileTab.BASIC)}
      />
      <SegmentButton
        active={value === ProfileTab.APPEARANCE}
        labelKey="MSG_PROFILE_TAB_APPEARANCE"
        iconName="face"
        onClick={handleClick(ProfileTab.APPEARANCE)}
      />
      <SegmentButton
        active={value === ProfileTab.FAVORITES}
        labelKey="MSG_PROFILE_TAB_FAVORITES"
        iconName="palette"
        onClick={handleClick(ProfileTab.FAVORITES)}
      />
      <SegmentButton
        active={value === ProfileTab.GAME_CASE}
        labelKey="MSG_PROFILE_TAB_GAME_CASE"
        iconName="videogame_asset"
        onClick={handleClick(ProfileTab.GAME_CASE)}
      />
    </div>
  );
};
